import { DropdownAnchor } from "./anchor";
import { Dropdown as _Dropdown } from "./dropdown";
import { PopOver } from "./pop-over";

export const Dropdown = Object.assign(_Dropdown, {
  Anchor: DropdownAnchor,
  PopOver: PopOver,
});
